<template>

  <div v-loading="loading" class="screen-container flex-column flex-auto">
    <div v-if="myData" class="flex-column flex-auto padding-top-10 padding-lr-10">
      <el-row :gutter="20" type="flex" class="flex-auto" style="flex:3">
        <el-col :span="6">
          <div class="myColumn flex-column">
            <div class="angle angle-lt"></div>
            <div class="angle angle-rt"></div>
            <div class="angle angle-lb"></div>
            <div class="angle angle-rb"></div>
            <div class="flex-row align-items-center justify-between">
              <div class="myColumn-title flex-row align-items-center justify-between">
                <template>
                  {{ titleSelected.name }}价格数据
                </template>

                <el-select v-if="mainIndex == 2 || mainIndex == 3" v-model="titleSelected.jiageSelected" value-key="name" size="mini" style="width:140px" @change="jiageChange">
                  <el-option v-for="(item,index) in titleSelected.jiageItemsList" :key="index" :label="item.name" :value="item"></el-option>
                </el-select>
                
                <el-select v-model="jiageSelected" size="mini" style="width:140px">
                  <el-option v-for="(item,index) in jiageItemsList" :key="index" :label="item" :value="item"></el-option>
                </el-select>
              </div>
            </div>
            <div class="column-con flex-column flex-auto"><Chart :option="jiageChart"  class="flex-auto"></Chart></div>
          </div>
          

          <div class="myColumn flex-column">
            <div class="angle angle-lt"></div>
            <div class="angle angle-rt"></div>
            <div class="angle angle-lb"></div>
            <div class="angle angle-rb"></div>
            <div class="flex-row align-items-center justify-between">
              <div class="myColumn-title flex-row align-items-center justify-between">
                <template>
                  {{ titleSelected.name }}供应数据
                </template>

                <el-select v-if="mainIndex == 1 || mainIndex == 3" v-model="titleSelected.gongyingName" size="mini" style="width:140px">
                  <el-option v-for="(item,index) in gongyingItemsList" :key="index" :label="item" :value="item"></el-option>
                </el-select>
              </div>
              
            </div>
            <div class="column-con flex-column flex-auto"><Chart :option="gongyingChart" :legendAutoHeight="false"  class="flex-auto"></Chart></div>
          </div>
          
        </el-col>
        <el-col :span="12">   
          <div class="flex-column flex-auto">
            <div class="angle angle-lt"></div>
            <div class="angle angle-rt"></div>
            <div class="angle angle-lb"></div>
            <div class="angle angle-rb"></div>

              <div class="padding-bottom-10">
                <div class="flex-row align-items-center justify-between">
                    <div class="myColumn-title font-size-16">
                      <div class="padding-left-20 column-tabs align-items-center justify-between">
                        <div v-for="title in titleList" :key="title.mainIndex" :class="{'active':mainIndex == title.mainIndex}" @click="changeTitle(title)">
                          {{title.name + '产业'}}
                        </div> 
                      </div>
                    </div>
                </div>
              </div>
              <el-row :gutter="20" type="flex" class="flex-auto" style="flex:3">
                <el-col :span="19">
                  <Chart :option="mapChart" :legendAutoHeight="false" class="flex-auto margin-top-10"></Chart>
                </el-col>
                <el-col :span="5">
                  <el-select v-if="mainIndex == 2" v-model="titleSelected.chanNengSelected" value-key="name" size="mini" style="width:100%">
                    <el-option v-for="(item,index) in titleSelected.chanNengItemsList" :key="index" :label="item.name" :value="item"></el-option>
                  </el-select>
                  <el-select v-if="mainIndex != 1" v-model="chanNengSelected" size="mini" style="width:100%" class="margin-tb-10">
                      <el-option v-for="(item,index) in chanNengItemsList" :key="index" :label="item" :value="item"></el-option>
                  </el-select>
                  <div ref="div_1" 
                        class="margin-bottom-10"
                        @mouseover="tableScroll.tableMouseOver_1=1" 
                        @mouseout="tableScroll.tableMouseOver_1=0" 
                        :style='{"height":0,"flex":"auto","overflow":tableScroll.tableMouseOver_1?"auto":"hidden","border-radius":"5px"}'>
                        <el-table
                          :data="myData[titleSelected.chanNengSelected ? '产能数据-' + titleSelected.chanNengSelected.name : '产能数据']"
                          :show-header="false"
                          size="small"
                          style="width: 100%">
                          <el-table-column
                          show-overflow-tooltip
                            prop="省份"
                            align="center"
                          >
                          </el-table-column>
                          <el-table-column
                            :prop="chanNengSelected"
                            align="center"
                          >
                          </el-table-column>
                        </el-table>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20" type="flex" class="flex-auto" style="flex:1">
                <el-col :span="24">
                  <div class="myColumn flex-column">
                    <div class="angle angle-lt"></div>
                    <div class="angle angle-rt"></div>
                    <div class="angle angle-lb"></div>
                    <div class="angle angle-rb"></div>
                    <div class="flex-row align-items-center justify-between">
                      <div class="myColumn-title">产业链流程图</div>
                    </div>
                    <div class="column-con flex-column flex-auto"><Chart :option="sankeyChart" :legendAutoHeight="true" class="flex-auto"></Chart></div>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20" type="flex" class="flex-auto" style="flex:2">
                <el-col :span="24">
                  <div class="myColumn flex-column">
                    <div class="angle angle-lt"></div>
                    <div class="angle angle-rt"></div>
                    <div class="angle angle-lb"></div>
                    <div class="angle angle-rb"></div>
                    <div class="flex-row align-items-center justify-between">
                      <div class="myColumn-title flex-row align-items-center justify-between">
                        <template>
                          下游消费占比
                        </template>

                        <el-select v-if="mainIndex == 2" v-model="titleSelected.xiaofeiSelected" value-key="name" size="mini" style="width:140px">
                          <el-option v-for="(item,index) in titleSelected.xiaofeiItemsList" :key="index" :label="item.name" :value="item"></el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="column-con flex-column flex-auto"><Chart :option="pieChart"  class="flex-auto"></Chart></div>
                  </div>
                </el-col>
              </el-row>

          </div>
        </el-col>
        <el-col :span="6">
          <div class="myColumn flex-column">
            <div class="angle angle-lt"></div>
            <div class="angle angle-rt"></div>
            <div class="angle angle-lb"></div>
            <div class="angle angle-rb"></div>
            <div class="flex-row align-items-center justify-between">
              <div class="myColumn-title flex-row align-items-center justify-between">
                <template>
                  {{titleSelected.name}}需求数据
                </template>

                <el-select v-if="mainIndex == 2" v-model="xuqiuSelected" size="mini" style="width:160px">
                  <el-option v-for="(item,index) in xuqiuItemsList" :key="index" :label="item.name" :value="item"></el-option>
                </el-select>
              </div>
            </div>
            <div class="column-con flex-column flex-auto"><Chart :option="xuqiuChart"  class="flex-auto"></Chart></div>
          </div>

          <div class="myColumn flex-column">
            <div class="angle angle-lt"></div>
            <div class="angle angle-rt"></div>
            <div class="angle angle-lb"></div>
            <div class="angle angle-rb"></div>
            <div>
              <div class="myColumn-title flex-row align-items-center justify-between">
                <template>
                  {{ titleSelected.name }}利润数据
                </template>

                <el-select v-if="mainIndex == 2" v-model="titleSelected.lirunSelected" value-key="name" size="mini" style="width:140px">
                  <el-option v-for="(item,index) in titleSelected.lirunItemsList" :key="index" :label="item.name" :value="item"></el-option>
                </el-select>
              </div>
            </div>
            <div class="column-con flex-column flex-auto"><Chart :option="lirunChart" class="flex-auto"></Chart></div>
          </div>
          
        </el-col>
      </el-row>
    </div>
  </div>

</template>

<script>


import Chart from "@/components/Chart";
import '@/common/china.js'//注册echarts中国地图
import XLSX from 'xlsx';
import { sanKeyEggData,sanKeyFeedData,sanKeyChickenData,sanKeyPigData } from './assets/js/sanKeyData'
export default {
  name: 'Home',
  components:{
    Chart,

  },
  data(){
    return {
      loading:false,
      myData:null,
      titleSelected:{},
      lirunSelected:{},
      jiageSelected:'',
      xuqiuSelected:'',
      chanNengSelected:'',
      titleList:[
        {
          mainIndex:1,
          name:'饲料',
          url:'/data/husbandry/FEED_DATA.xlsx',
          jiageUnit:'元/吨',
          gongyingUnit:'吨/日',
          xuquUnit:'吨',
          lirunUnit:'元/吨',
          chanNengUnit:'吨/日',
          gongyingName:'大豆压榨量',
          chanNengName:'2023年豆粕产能（剔除关停、在建、拟建产能）',
          sanKeyData:sanKeyFeedData
        },
        {
          mainIndex:2,
          name:'生猪',
          url:'/data/husbandry/PIG_DATA.xlsx',
          jiageUnit:'元/吨',
          gongyingUnit:'头',
          xuquUnit:'',
          lirunUnit:'元/吨',
          chanNengUnit:'万头',
          gongyingName:'卓创监测118家样本企业生猪出栏量',
          chanNengName:'',
          sanKeyData:sanKeyPigData,
          jiageSelected: {
              name:'生猪',
              unit:'元/公斤'
          },
          jiageItemsList:[
            {
              name:'生猪',
              unit:'元/公斤'
            },
            {
              name:'二元母猪',
              unit:'元/头'
            },
            {
              name:'仔猪',
              unit:'元/头'
            },
          ],
          lirunSelected: {
              name:'养殖盈利',
              unit:'元/头'
          },
          lirunItemsList:[
            {
              name:'养殖盈利',
              unit:'元/头'
            },
            {
              name:'屠宰毛利',
              unit:'元/头'
            },
          ],
          xiaofeiSelected: {
              name:'消费结构占比',
              unit:'%'
          },
          xiaofeiItemsList:[
            {
              name:'消费结构占比',
              unit:'%'
            },
            {
              name:'消费渠道占比',
              unit:'%'
            },
          ],
          chanNengSelected: {
              name:'能繁母猪存栏量',
              unit:'万头'
          },
          chanNengItemsList:[
            {
              name:'能繁母猪存栏量',
              unit:'万头'
            },
            {
              name:'生猪存栏量',
              unit:'万头'
            },
          ]
        },
        {
          mainIndex:3,
          name:'肉鸡',
          url:'/data/husbandry/CHICKEN_DATA.xlsx',
          jiageUnit:'元/吨',
          gongyingUnit:'',
          xuquUnit:'%',
          lirunUnit:'',
          chanNengUnit:'',
          gongyingName:'国内祖代种鸡存栏量（万套）',
          chanNengName:'2023年豆粕产能（剔除关停、在建、拟建产能）',
          sanKeyData:sanKeyChickenData,
          jiageSelected: {
              name:'白羽肉鸡价格',
              unit:'元/斤'
          },
          jiageItemsList:[
            {
              name:'白羽肉鸡价格',
              unit:'元/斤'
            },
            {
              name:'白羽肉鸡鸡苗',
              unit:'元/羽'
            },
            {
              name:'白羽肉鸡分割产品',
              unit:'元/公斤'
            },
          ],
        },
        {
          mainIndex:4,
          name:'鸡蛋',
          url:'/data/husbandry/EGG_DATA.xlsx',
          jiageUnit:'元/斤',
          gongyingUnit:'万吨',
          xuquUnit:'吨',
          lirunUnit:'元',
          chanNengUnit:'亿只',
          gongyingName:'全国鸡蛋产量',
          chanNengName:'产蛋鸡存栏量',
          sanKeyData:sanKeyEggData,
        }

      ],
      mainIndex:1,
      tableScroll:{
        tableMouseOver_1:0,
      },
      timer:''
    }
  },
  computed:{
    jiageChart(){
      let title = "价格数据"
      let unit = this.titleSelected.jiageUnit
      let jiageSelected = this.jiageSelected;
      if(this.mainIndex == 2 || this.mainIndex == 3){
        title += "-" + this.titleSelected.jiageSelected.name
        unit = this.titleSelected.jiageSelected.unit
        jiageSelected = this.jiageSelected
      }
      if(this.myData&&this.myData[title]&&this.myData[title].length && jiageSelected){
        let chartData=this.myData[title]
        let opt =JSON.parse(JSON.stringify(this.$defaultChartOption)) 
        opt.dataZoom.show = true;
        opt.dataZoom.start = 80
        opt.legend.data.push(jiageSelected)
        opt.grid.right=45
        opt.xAxis.boundaryGap = true
        opt.xAxis.data=chartData.map(v=>{return v['日期']})
        opt.xAxis.axisLabel={
          showMinLabel:true,
          showMaxLabel:true,
          rotate:-45,
        }
        opt.yAxis.axisLabel.formatter= '{value}' + unit
        opt.series=opt.legend.data.map(v=>{
          return {
              name:v,
              data:  chartData.map(vv=>{return parseFloat(vv[v]) }),
              type: 'line',
              endLabel:{
                show:false,
                fontWeight:'bold',
                formatter:'{c}' + unit
              },         
              labelLayout:{ moveOverlap:'shiftY'},
          }
        })
        opt.tooltip={
          trigger:'axis',
          formatter: (params)=>{
            var str=`<div>${params[0].axisValue}</div>`
            params.forEach((val)=>{
                str+=`<div>${val.marker}${val.seriesName}：${this.$numFormat(val.data,2,'-')} ${unit}</div>`
            })
            return str
          },
        }
        return opt
      }else{
        return null
      }
      
    },
    jiageItemsList(){
      let title = "价格数据"
      if(this.mainIndex == 2 || this.mainIndex == 3){
        title += "-" + this.titleSelected.jiageSelected.name
      }
      let list=[]
      if(this.myData&&this.myData[title]&&this.myData[title].length){
      for(let key in this.myData[title][0]){
          if(key!='日期'&&key!='全国淘汰鸡均价（元/斤）'){
            list.push(key)
          }
        }
      }
      return list;
    },
    gongyingItemsList(){
      let title = "供应数据"
      if(this.myData&&this.myData[title]&&this.myData[title].length){
        let list=[]
        for(let key in this.myData[title][0]){
            if(key!='日期'){
              list.push(key)
            }
          }
        return list
      }else{
        return []
      }
    },
    gongyingChart(){
      let title = "供应数据"
      let unit = this.titleSelected.gongyingUnit;
      if(this.myData&&this.myData[title]&&this.myData[title].length){
        let chartData=this.myData[title]
        let opt =JSON.parse(JSON.stringify(this.$defaultChartOption)) 
        opt.dataZoom.show = true;
        opt.dataZoom.startValue = chartData.length - 30 
        opt.xAxis.boundaryGap = true
        opt.xAxis.data=chartData.map(v=>{return v['日期']})
        opt.xAxis.axisLabel={
          showMinLabel:true,
          showMaxLabel:true,
          rotate:-45,
        }
        opt.yAxis.name= unit
        let name = this.titleSelected.gongyingName;
        opt.series=[{
              name:name,
              color:this.$defaultChartOption.color[1],
              data:  chartData.map(v=>{return v[name]}),
              type: 'bar',
          }
        ]
        opt.tooltip={
          trigger:'axis',
          formatter: (params)=>{
            var str=`<div>${params[0].axisValue}</div>`
            params.forEach((val)=>{
                str+=`<div>${val.marker}${val.seriesName}：${this.$numFormat(val.data,2,'-')} ${unit}</div>`
            })
            return str
          },
        }
        return opt
      }else{
        return null
      }
    },
    lirunChart(){
      let title = "利润数据"
      let unit= this.titleSelected.lirunUnit
      if(this.mainIndex == 2){
        title += "-" + this.titleSelected.lirunSelected.name
        unit = this.titleSelected.lirunSelected.unit
      }
      if(this.myData&&this.myData[title]&&this.myData[title].length){
        let chartData=this.myData[title]
        let opt =JSON.parse(JSON.stringify(this.$defaultChartOption)) 
        for(let key in chartData[0]){
          if(key!='日期'){
            opt.legend.data.push(key)
          }
        }
        opt.dataZoom.show = true;
        opt.dataZoom.start = 85 
        opt.grid.right=45
        opt.xAxis.boundaryGap = true
        opt.xAxis.data=chartData.map(v=>{return v['日期']})
        opt.xAxis.axisLabel={
          showMinLabel:true,
          showMaxLabel:true,
          rotate:-45,
        }
        opt.yAxis.axisLabel.formatter= '{value}' + unit
        opt.series=opt.legend.data.map(v=>{
          return {
              name:v,
              data:  chartData.map(vv=>{return parseFloat(vv[v]) }),
              type: 'line',
              endLabel:{
                show:false,
                fontWeight:'bold',
                formatter:'{c}' + unit
              },
              areaStyle:{
                opacity:0.4,
              },         
              labelLayout:{ moveOverlap:'shiftY'},
          }
        })
        opt.tooltip={
          trigger:'axis',
          formatter: (params)=>{
            var str=`<div>${params[0].axisValue}</div>`
            params.forEach((val)=>{
                str+=`<div>${val.marker}${val.seriesName}：${this.$numFormat(val.data,2,'-')} ${unit}</div>`
            })
            return str
          },
        }
        return opt
      }else{
        return null
      }
    },
    xuqiuChart(){
      let title = "需求数据"
      let unit = this.titleSelected.xuquUnit;
      if(this.myData&&this.myData[title]&&this.myData[title].length){
        let chartData=this.myData[title]
        let opt =JSON.parse(JSON.stringify(this.$defaultChartOption)) 
        if(this.mainIndex == 2){
          opt.legend.data.push(this.xuqiuSelected)
        }else{
          for(let key in chartData[0]){
          if(key!='日期'){
            opt.legend.data.push(key)
          }
        }
        }
        
        opt.smooth = true;
        opt.dataZoom.show = true;
        opt.dataZoom.startValue = chartData.length - 30 
        opt.grid.right=45
        opt.xAxis.boundaryGap = true
        opt.xAxis.data=chartData.map(v=>{return v['日期']})
        opt.xAxis.axisLabel={
          showMinLabel:true,
          showMaxLabel:true,
          rotate:-45,
        }
        opt.yAxis.axisLabel.formatter= '{value}'+unit
        opt.series=opt.legend.data.map(v=>{
          return {
              name:v,
              data:  chartData.map(vv=>{return parseFloat(vv[v]) }),
              type: 'line',
              endLabel:{
                show:false,
                fontWeight:'bold',
                formatter:'{c}'+unit
              },         
              labelLayout:{ moveOverlap:'shiftY'},
              connectNulls:true,
          }
        })
        opt.tooltip={
          trigger:'axis',
          formatter: (params)=>{
            var str=`<div>${params[0].axisValue}</div>`
            params.forEach((val)=>{
                str+=`<div>${val.marker}${val.seriesName}：${this.$numFormat(val.data,2,'-')} ${unit}</div>`
            })
            return str
          },
        }
        return opt
      }else{
        return null
      }
    },
    xuqiuItemsList(){
      let title = "需求数据"
      if(this.myData&&this.myData[title]&&this.myData[title].length){
        let list=[]
        for(let key in this.myData[title][0]){
            if(key!='日期'){
              list.push(key)
            }
          }
        return list
      }else{
        return []
      }
    },
    pieChart(){
      let title = "下游消费占比数据"
      if(this.mainIndex == 2){
        title += "-" + this.titleSelected.xiaofeiSelected.name
      }
      if(this.myData&&this.myData[title]&&this.myData[title].length){
        let chartData=this.myData[title]
        let length = 100/chartData.length
        let items=Object.keys(chartData[0]).filter(v=>v!='日期')
        let opt = {
          backgroundColor:'transparent',
          title: chartData.map((v,i)=>{
            return {
              text:v['日期'],
              left: `${(i+1)*(length)-length/2 - 0.5}%`,
              top: '40%',
              textAlign: 'center'
            }
          }),
          tooltip: {
            trigger: 'item'
          },
          legend: {
            bottom: '0%',
            left: 'center'
          },
          series: chartData.map((v,i)=>{
            return {
              type: 'pie',
              radius: ['35%', '80%'],
              center: ['50%', '45%'],
              data: items.map(vv=>{return {name:vv,value:v[vv]}}),
              itemStyle: {
                  borderRadius: 5,
                  borderColor: '#051841',
                  borderWidth: 2
              },
              label: {
                show:true,
                position: 'inside',
                alignTo: 'none',
                bleedMargin: 5,
                width:80,
                overflow:'truncate',
                textBorderWidth:1,
                formatter:'{b}:\n{c}%'
              },
              left: `${i*(length)}%`,
              right: `${100-i*(length)-(length)}%`,
              top: 0,
              bottom: 0
            }
          }),
        };
        return opt
      }else{
        return null
      }

    },
    mapChart(){
      let title = "产能数据"
      let unit = this.titleSelected.chanNengUnit;
      let name = this.titleSelected.chanNengName;
      if(this.mainIndex == 2){
        title += "-" + this.titleSelected.chanNengSelected.name
        unit = this.titleSelected.chanNengSelected.unit;
        name = this.titleSelected.chanNengSelected.name
      }
     
      
      //肉鸡
      if(this.mainIndex == 3){
        name = this.chanNengSelected
      }
      if(this.myData&&this.myData[title]&&this.myData[title].length){
        let chartData=this.myData[title]
        let opt = {
          backgroundColor: 'transparent',
          title:{
            text:'产能分布',
            textStyle:{
              fontSize:16
            }
          },
          tooltip:{
            formatter: (params)=>{
              var str=`
                  <div>${params.seriesName}</div>
                  <div>${params.name}：${  this.$numFormat(params.value,2,'-')} ${unit}</div>
              `
              return str
            },
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
          },
          visualMap:{
            type:'continuous',
            left:'right',
            max:Math.max(...chartData.map(v=>{return parseFloat(v[this.chanNengSelected])||0})),
            mix:0,
            inRange:{
              color: ['#d7fbb1', '#5600e4'],
            },
            text:[Math.max(...chartData.map(v=>{return parseFloat(v[this.chanNengSelected])||0})),0],
            
          },
          series:[{
            type:'map',
            map:'china',    
            name:name,
            roam: true,
            boundingCoords: [
                // 定位左上角经纬度
                [78, 53],
                // 定位右下角经纬度
                [130, 20]
            ],
            selectedMode: false,
            itemStyle:{
              areaColor:'rgba(160,160,160,0.3)',
              borderColor:'#00fffc',
            },
            emphasis:{
              itemStyle:{
                areaColor:'rgba(160,160,160,0.3)',
                borderColor:'#fff',
              },
              label:{
                show:true,
              }
            },
            data:chartData.map(v=>{
              return {
                name:v['省份'],
                value:v[this.chanNengSelected],
                label:{
                  show:true,
                  textBorderColor:'#fff',
                  textBorderWidth:2,
                  formatter: (params)=>{
                    return params.value || '';
                  },
                },
                // tooltip:{
                //   formatter: '{b}: {c}'
                // },
                emphasis:{
                  itemStyle:{
                      areaColor:'#ffc069'
                  }
                }
              }
            })
          }]
        }
        if(this.mainIndex != 3){
          opt.title.subtext = '单位：' + unit
        }
        return opt
      }
      else{
        return null
      }
      
    },
    sankeyChart(){
        let data=[]
        let sanKeyData = this.titleSelected.sanKeyData
        for(let item of sanKeyData){
          if(!data.some(v=>v.name==item.source)){
            data.push({name:item.source,itemStyle:{color:this.$defaultChartOption.color[item.type]}})
          }
          if(!data.some(v=>v.name==item.target)){
            data.push({name:item.target,itemStyle:{color:this.$defaultChartOption.color[item.type]}})
          }
        }
        let opt = {
          backgroundColor: 'transparent',
          title:{
            subtext:''
          },
          tooltip:{
            formatter:'{b}'
          },
          series: {
            type: 'sankey',
            right:80,
            top:10,
            bottom:10,
            nodeGap:10,            
            nodeWidth:10,
            layoutIterations: 512,
            
            lineStyle:{
              color:'gradient'
            },
            label:{
              show:true,
              formatter: '{b}',
              width:70,
              overflow:'break'
            },
            emphasis: {
              focus: 'adjacency'
            },
            data:data,
            labelLayout:{
              moveOverlap:'shiftX'
            },
            links: sanKeyData
          }
        }
        return opt
      
    },
    chanNengItemsList(){
      let title = "产能数据"
      if(this.mainIndex == 2){
        title += "-" + this.titleSelected.chanNengSelected.name
      }
      if(this.myData&&this.myData[title]&&this.myData[title].length){
        let list=[]
        for(let key in this.myData[title][0]){
            if(key!='省份'){
              list.push(key)
            }
          }
        return list
      }else{
        return []
      }
    },
  },
  created(){
    this.titleSelected = this.titleList[0];
    this.$nextTick(()=>{
      this.getData(this.titleSelected.url)
    })
   
    
    
  },
  methods:{
    getData(url){
      this.loading=true
      this.$instance.get(url,{
        baseURL:window.location.href.split('#')[0],
        responseType:'arraybuffer',
        headers: {
          'Content-Type': 'application/vnd.ms-excel', // 或 application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
        },
      })
      .then(res=>{
        this.$message.closeAll()
        this.loading=false
        let data = new Uint8Array(res.data)
        let wb = XLSX.read(data, {type:"array"})
        let sheets = wb.Sheets // 获取文档数据
        let myData={}
        for(let key in sheets){
          myData[key]=XLSX.utils.sheet_to_json(sheets[key],{raw:false})
        }
        this.myData=myData
        this.$nextTick(()=>{
          this.init()
        })

      })
      .catch(()=> {
        this.loading=false
      }); 
    },
    scroll(element,step){
      let obj=this.$refs[element]
      //清除定时器
      if(this.timer){
        clearTimeout(this.timer)
      }
      //  obj.scrollHeight>obj.clientHeight&&(obj.innerHTML+=obj.innerHTML);
      let fun=()=>{
        if(!this.tableScroll[`tableMouseOver_${element.split('_')[1]}`]){
          if(obj.scrollTop%step||!this.tableScroll[`tableMouseOver_${element.split('_')[1]}`]){
            obj.scrollTop++
            // obj.scrollTop%=obj.scrollHeight>>1
            if(obj.scrollTop>=(obj.scrollHeight-obj.clientHeight)){
              obj.scrollTop=0
            }
          }
        }
        this.timer = setTimeout(fun,obj.scrollTop%step&&obj.scrollTop<(obj.scrollHeight-obj.clientHeight-1)?10:3000)
      }
      fun()
    },
    init(){
      this.$nextTick(()=>{this.scroll('div_1',40)})
      this.chanNengSelected = this.chanNengItemsList[0]
      this.jiageSelected = this.jiageItemsList[0]
      this.xuqiuSelected = this.xuqiuItemsList[0]
    },
    changeTitle(title){
      this.getData(title.url)
      this.mainIndex = title.mainIndex
      this.titleSelected = title
    },
    jiageChange(){
      this.jiageSelected = this.jiageItemsList[0]
    }
  },
  mounted(){
   
  },
  watch: {
   
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
<style scoped lang="scss">
@import './assets/css/common.scss';
.num-block{
  background:url('~@/view/template_02/assets/images/num_bg.png') no-repeat;
  background-size: 100% 100%;
  .num-item{
    background:url('~@/view/template_02/assets/images/num_item_bg.png') no-repeat;
    background-size: 100% 100%;
    padding-bottom:20px
  }
  .icon{
    background:url('~@/view/template_02/assets/images/num_icon.png') no-repeat;
    width: 26px;
    background-size: contain;
    padding-bottom:20px;
    transform: translateY(-24%);
  }
}
</style>
